import { defineMessages } from "react-intl";
import {
	diabetesMellitusTypeMessages,
	diseasesMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/endocrineDiseases";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	endocrineDiseases: {
		id: "form.endocrine_diseases",
		defaultMessage: "Endokrin betegségek"
	},
	diseases: {
		id: "form.endocrine_diseases.diseases",
		defaultMessage: "Betegség"
	},
	diabetesMellitusType: {
		id: "form.endocrine_diseases.diabetes_mellitus_type",
		defaultMessage: "Diabetes mellitus típus"
	},
	comment: {
		id: "form.endocrine_diseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	diseases: {
		type: "field",
		path: ["diseases"],
		label: messages.diseases,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: diseasesMessages } }
	},
	diabetesMellitusType: {
		type: "field",
		path: ["diabetesMellitusType"],
		label: messages.diabetesMellitusType,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: diabetesMellitusTypeMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.diseases }] },
		{ columns: [{ width: 12, field: fields.diabetesMellitusType }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "endocrineDiseases",
	value: {
		title: messages.endocrineDiseases,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
